import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installScrollAnimations from './utils/scroll-animations'

// 引入全局样式
import '@/assets/styles/global.scss'

Vue.config.productionTip = false
installScrollAnimations(Vue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
